import { createContext, useContext } from 'react';
// @ts-expect-error lib not typed
import Cookies from 'js-cookie';
export const MobileLoginContext = /*#__PURE__*/createContext(false);
export const useIsMobileLogin = () => {
  const contextValue = useContext(MobileLoginContext);
  const cookieValue = Cookies.get('hs_reauth');
  return contextValue || Boolean(cookieValue);
};